import userInvitesSignal from 'signals/UserInvites.signal';
import loaderSignal from 'signals/Loader.signal';
import alertSignal from 'signals/Alert.signal';
import api from 'api/api';
import { fetchAndSetUserInvites } from '../../UserInvitations.helpers';

export const showUserInvitationModal = (selectedUserInvitation) =>
  userInvitesSignal.update({ selectedUserInvitation });
export const hideUserInvitationModal = () =>
  userInvitesSignal.update({ selectedUserInvitation: null });

export const copyInvitationLinkToClipboard = async (text) => {
  const showSuccess = () =>
    alertSignal.update({
      variant: 'success',
      type: 'notification',
      message: 'Successfully copied invitation link to clipboard.',
    });

  try {
    await navigator.clipboard.writeText(text);
    showSuccess();
  } catch {
    alertSignal.update({
      type: 'notification',
      message: 'Copy failed. Please copy the link manually.',
    });
  }
};

export const updateUserInvitePortal = async (e) => {
  const { selected } = userInvitesSignal.value;
  const user = {
    portal: e.target.value,
  };
  loaderSignal.update({
    isContentLoading: true,
    message: 'Updating user invitation...',
  });
  try {
    await api.put({
      path: `/v2/userInvites/${user.id}`,
      body: { portal: user.portal },
    });
  } catch (err) {
    loaderSignal.update({ isAppLoading: false });
    alertSignal.update({ type: 'notification', message: err });
  } finally {
    loaderSignal.reset();
  }
};

export const resendUserInvitation = async () => {
  const { selectedUserInvitation } = userInvitesSignal.value;
  loaderSignal.update({
    isContentLoading: true,
    message: 'Resending invite...',
  });
  try {
    await api.post({
      path: '/v2/userInvites',
      body: {
        resend: true,
        id: selectedUserInvitation.id,
        notes: selectedUserInvitation.notes,
      },
    });
    userInvitesSignal.update({
      selectedUserInvitation: null,
    });
    await fetchAndSetUserInvites();
    return alertSignal.update({
      variant: 'success',
      type: 'notification',
      message: 'Successfully resent invitation.',
    });
  } catch (error) {
    return alertSignal.update({
      type: 'notification',
      message: 'Unable to fetch user Invites',
      error,
    });
  } finally {
    loaderSignal.reset();
  }

  // TODO:
  // this piece of code belongs to user approval and can be used accordingly
  // else {
  //   const approvedUser = {
  //     adminApprovedId: parseInt(userAccountSignal.value.userData.id, 10),
  //     status: 'APPROVED',
  //     portal: selected?.portal,
  //     id: selected?.id,
  //   };
  //   loaderSignal.update({ isContentLoading: true });
  //   try {
  //     await api.post({ path: '/userInvites', body: approvedUser });
  //     loaderSignal.update({ isContentLoading: false });
  //   } catch (err) {
  //     loaderSignal.update({ isContentLoading: false });
  //     alertSignal.update({ type: 'notification', message: 'Error approving user please try again' });
  //   }
  // }
};

export default {
  showUserInvitationModal,
  hideUserInvitationModal,
  resendUserInvitation,
};

export const handleReinviteUserNoteChange = (e) => {
  userInvitesSignal.update({
    selectedUserInvitation: {
      ...userInvitesSignal.value.selectedUserInvitation,
      notes: e.target.value,
    }
  })
};
